import { z } from 'zod';

import { fetchJson } from '@/lib/http';

const adminUserSchema = z.object({
  id: z.string().uuid(),
  email: z.string().email(),
  displayName: z.string(),
  authProvider: z.enum(['LOCAL', 'BITRIX24']),
  role: z.enum(['USER', 'ADMIN']),
  isActive: z.boolean(),
  avatarUrl: z.string().nullable(),
  transcriptionsCount: z.number().int().nonnegative(),
  createdAt: z.string(),
  updatedAt: z.string(),
  lastSyncedAt: z.string().nullable(),
});

const adminUsersResponseSchema = z.object({
  items: z.array(adminUserSchema),
});

export type AdminUser = z.infer<typeof adminUserSchema>;

export function fetchAdminUsers(signal?: AbortSignal) {
  return fetchJson('/admin/users', adminUsersResponseSchema, signal !== undefined ? { signal } : undefined);
}

export function updateAdminUser(
  id: string,
  patch: { role?: 'USER' | 'ADMIN'; isActive?: boolean },
  signal?: AbortSignal,
) {
  return fetchJson(`/admin/users/${encodeURIComponent(id)}`, adminUserSchema, {
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(patch),
    ...(signal !== undefined ? { signal } : {}),
  });
}
